<div class="kp-questioner p-2 relative" *ngIf="question">
	<ngx-spinner name="questioner-wizard" [fullScreen]="false" type="timer"></ngx-spinner>
	<form class="pt-2" #resumeForm="ngForm" *ngIf="show" [ngSwitch]="questionKey">
		<div *ngSwitchCase="'Karpasha'">
			<h3 class="lh-sm mx-2">می‌خوای کارپیشه، شما رو مستقیماً به کارفرما معرفی کنه؟</h3>
			<div class="py-1 d-flex align-items-center justify-content-center container-capped-xs">
				<a class="btn btn-primary mx-3"
					[routerLink]="'/seeker/karpasha'"
					ga-event="Karpasha|questioner|want"> بله </a>
				<button class="btn btn-secondary  mx-3" (click)="skip()" ga-event="Karpasha|questioner|no"> نه </button>
			</div>
		</div>
		<div *ngSwitchCase="'User-Suggest'">
			<ng-container *ngIf="!suggestions || !suggestions[userSuggestion]?.length">
				<b><i class="fa fa-robot"></i>: دنبال چه کاری میگردی؟</b>
				<app-search-box #searchBox name="search" [showLocation]="false" [navigateEnabled]="false"
					[(ngModel)]="searchParams" (on-search)="load($event)"></app-search-box>
			</ng-container>

			<ng-container *ngIf="suggestions && suggestions[userSuggestion]?.length">
				<ng-container
					*ngTemplateOutlet="toggleItems;context:{type:userSuggestion,message:userSuggestionMessage[userSuggestion]}">
				</ng-container>
			</ng-container>
		</div>
		<div *ngSwitchCase="'User-NoSuggest'">
			<ng-container
				*ngTemplateOutlet="toggleItems;context:{type:userSuggestion,message:userNoSuggestionMessage[userSuggestion]}">
			</ng-container>
		</div>

		<div *ngSwitchCase="'Name'">
			<label class="py-1 text-right">
				<b><i class="fa fa-robot"></i>: لطفا اسم و فامیلت رو وارد کن</b>
				<input type="text" class="form-control" name="name" placeholder="نام و نام خانوادگی" [(ngModel)]="user.Name"
					required />
			</label>
		</div>

		<div *ngSwitchCase="'Seeker.Skills'">
			<ng-container
				*ngTemplateOutlet="toggleItems;context:{type:'skills',message:'چنتا از این مهارت‌ها رو همین الان داری؟'}">
			</ng-container>
		</div>

		<div *ngSwitchCase="'Seeker.Experiences'">
			<ng-container
				*ngTemplateOutlet="toggleItems;context:{type:'positions',message:'از بین این مشاغل تجربه‌ی کدوم‌ها رو داری؟'}">
			</ng-container>
		</div>

		<div *ngSwitchCase="'Seeker.JobAlertSettings.Searches'">
			<ng-container
				*ngTemplateOutlet="toggleItems;context:{type:'searches',message:'اگر بخوای بین همه‌ی آگهی‌های استخدام ایران جستجو کنی، چنتا از نزدیکترین جستجوهات کدوماس؟'}">
			</ng-container>
		</div>

		<div *ngSwitchCase="'Seeker.ExpiredPromote'">
			<ng-container *ngIf="user?.Seeker?.ExpiredPromote">
				<div class="h6"><i class="fa fa-robot"></i>: تبریک! کارپیشه دیگه می‌دونه چه شغلی و کدوم آگهی‌های استخدام به دردت
					می‌خوره.
				</div>
			</ng-container>
			<app-seeker-vanguard-packages page="questioner" [minimal]="true"></app-seeker-vanguard-packages>
			<ng-container *ngIf="!user?.Seeker?.ExpiredPromote">
				<div class="text-left flex-fill">
					<div class="btn btn-sm btn-primary mt-2" (click)="removePid()">
						<i class="fa fa-robot ml-1"></i>
						سوال بعدی
					</div>
				</div>
			</ng-container>

		</div>

		<div *ngSwitchCase="'Seeker.Gender'">
			<b><i class="fa fa-robot"></i>: جنسیت‌ت رو ثبت کن</b>
			<div class="d-flex w-100 justify-content-center text-center">
				<div class="kp-card p-4 pointer fs-xxl" (click)="user.Seeker.Gender=0;update()"><i
						class="fa fa-male"></i><br />مرد</div>
				<div class="kp-card p-4 pointer fs-xxl" (click)="user.Seeker.Gender=1;update()"><i
						class="fa fa-female"></i><br />زن</div>
			</div>
		</div>

		<div *ngSwitchCase="'Seeker.Birthday'">
			<div class="d-flex justify-content-between">
				<b>تاریخ تولد:</b>
			</div>
			<div>
				<app-calendar name="birthday" [(ngModel)]="user.Seeker.Birthday" default-year="1375">
				</app-calendar>
			</div>
		</div>

		<div *ngSwitchCase="'Seeker.MilitaryStatus'" class="py-1">
			<div class="d-flex justify-content-between">
				<b>وضعیت نظام وظیفه:</b>
			</div>
			<div>
				<select [(ngModel)]="user.Seeker.MilitaryStatus" name="military" required
					[class.f-gray]="user.Seeker.MilitaryStatus=='0'">
					<option value="0" disabled selected hidden>وضعیت نظام وظیفه</option>
					<option [value]="1">مشمول</option>
					<option [value]="6">پایان خدمت</option>
					<option [value]="4">معافیت غیرپزشکی</option>
					<option [value]="3">معافیت پزشکی</option>
					<option [value]="5">خرید خدمت</option>
					<option [value]="7">نامشخص</option>
				</select>
			</div>
		</div>

		<div *ngSwitchCase="'Seeker.MaritalStatus'">
			<div class="d-flex justify-content-between">
				<b>وضعیت تاهل:</b>
			</div>
			<div>
				<select [(ngModel)]="user.Seeker.MaritalStatus" name="MaritalStatus"
					[class.f-gray]="!user.Seeker.MaritalStatus">
					<option [value]="undefined" disabled selected hidden>وضعیت تاهل شما کدام است؟</option>
					<option [value]="1">مجرد</option>
					<option [value]="2">متاهل</option>
				</select>
			</div>
		</div>

		<div *ngSwitchCase="'Seeker.JobAlertSettings.AllowedDistance'">
			<b><i class="fa fa-robot"></i>: کدوم شهر زندگی میکنی؟</b>
			<app-location [accept-level]="2" name="location" required [(ngModel)]="location"
				placeholder="در کدام شهر سکونت دارید؟"></app-location>
			<div class="my-1 " *ngIf="location.City">
				<div class="mb-1">
					<input type="text" class="form-control" name="district" placeholder="محله" [(ngModel)]="location.District" />
				</div>

				<b><i class="fa fa-robot"></i>: تا چند کیلومتر حاضری برای کار از {{location.City}} خارج شی؟</b>
				<div class="overflow-x-auto scroll-sm">
					<div class="btn-group btn-group-sm " role="group">
						<button type="button" class="btn btn-secondary px-2" (click)="locationInfo.AllowedDistance=0"
							[class.active]="locationInfo.AllowedDistance==0">فقط {{location.City}}</button>
						<button type="button" class="btn btn-secondary ltr px-2" (click)="locationInfo.AllowedDistance=50"
							[class.active]="locationInfo.AllowedDistance==50">50 km</button>
						<button type="button" class="btn btn-secondary ltr px-2" (click)="locationInfo.AllowedDistance=100"
							[class.active]="locationInfo.AllowedDistance==100">100 km</button>
						<button type="button" class="btn btn-secondary ltr px-2" (click)="locationInfo.AllowedDistance=200"
							[class.active]="locationInfo.AllowedDistance==200">200 km</button>
						<button type="button" class="btn btn-secondary px-2" (click)="locationInfo.AllowedDistance=null"
							[class.active]="locationInfo.AllowedDistance==null">هر جا بود</button>
					</div>
				</div>
			</div>
		</div>

		<div *ngSwitchCase="'Seeker.Photo'">
			<input type="file" #file (change)="uploadPhoto(file.files[0])" style="display:none;" accept=".jpg,.jpeg,.png">
			<img class="cover circle pointer shadow-kp" style="width: 150px; height: 150px;object-fit: contain;"
				[src]="user.Seeker.Photo ? assetsUrl + user.Seeker.Photo : '/assets/images/clipart/avatar-1.svg'"
				onerror="this.src='/assets/images/clipart/avatar-1.svg?err'" (click)="file.click()">
		</div>

		<div *ngSwitchCase="'Seeker.Email'">
			<label class="py-1 text-right">
				<b>ایمیل:</b>
				<input type="email" [pattern]="patterns.email" dir="ltr" class="form-control" name="email" placeholder="ایمیل"
					[(ngModel)]="user.Seeker.Email" />
			</label>
		</div>

		<div *ngIf="!onLogin.observers.length" class="d-flex pt-2">
			<div class="text-right">
				<div *ngIf="snoozable" class="btn btn-sm btn-link " (click)="skip()">
					<i class="fa fa-clock ml-1"></i>
					بعدا بپرس
				</div>
			</div>
			<div class="text-left flex-fill" *ngIf="!question?.hideBtn || question.hideBtn()!=true">
				<div class="btn btn-sm btn-primary" (click)="(!user && question.login) ? loginModal.open() : update()">
					<i class="fa fa-save ml-1"></i>
					ذخیره و بعدی
				</div>
			</div>
		</div>

	</form>
</div>

<ngx-smart-modal #loginModal identifier="loginModal">
	<div class="p-3">
		<div class="kp-message kp-message-warning border m-0">
			<i class="fa fa-exclamation-triangle fs-xl ml-1 "></i>
			برای ذخیره شماره همراه‌ت رو وارد کن:
		</div>
		<app-login (login)="update(true)" [inline]="true" heading="" intro=""></app-login>
	</div>
</ngx-smart-modal>

<ng-template #toggleItems let-type="type" let-message="message">
	<b><i class="fa fa-robot "></i> : {{message}}</b>
	<div class="d-md-flex flex-wrap" *ngIf="suggestions && suggestions[type]">
		<div class="w-md-50" *ngFor="let item of suggestions[type]|slice:0:(suggestions[type]._limit||suggestionPage)">
			<div class=" border m-1 order-1 pointer px-2 question-toggle-item" [class.active]="includesInArray(type, item)"
				(click)="toggleInArray(type, item)">
				<i class="fa ml-1" [class.fa-check]="includesInArray(type, item)"
					[class.fa-plus]="!includesInArray(type, item)"></i>
				{{item}}
			</div>
		</div>
		<div *ngIf="!((suggestions[type]._limit||suggestionPage)>=suggestions[type].length)"
			class="mx-auto m-1 order-1 pointer px-2"
			(click)="suggestions[type]._limit=(suggestions[type]._limit||suggestionPage)*2">
			بیشتر <i class="fa fa-caret-down"></i>
		</div>
		<div *ngIf="suggestions[type].length && suggestions[type]._new==null" (click)="suggestions[type]._new=''"
			class="mx-auto m-1 order-1 pointer px-2">
			<i class="fa fa-plus"></i>&nbsp;یکی اضافه کن
		</div>
		<form *ngIf="!suggestions[type].length || suggestions[type]._new!=null" class="mx-auto d-flex align-items-center"
			(submit)="addInArray(type)">
			<input name="new-item" [(ngModel)]="suggestions[type]._new" autofocus class="py-1" />
			<button type="submit" class="btn btn-icon-circle mr-1 btn-primary">
				<i class="fa fa-plus pointer fs-lg"></i>
			</button>
		</form>
		<!-- <div (click)="skip(type)" class="mx-auto border m-1 order-1 pointer px-2 rounded-xl question-toggle-item">
				<i class="fa fa-times"></i>&nbsp;اصلا ندارم!
			</div> -->
	</div>
</ng-template>

<div class="d-none questioner-suggestion">{{suggestions|json}}</div>